import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import LoadingCube from 'sub_components/Common/LoadingCube';
//import { BloxButton } from 'styled_components/Common/BloxButton';
import { UserApi } from 'services/user';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
//import { BloxButton } from 'styled_components/Common/BloxButton';

const PortalAccessDetails = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 448px;
	height: 100%;
	color: ${props => props.theme.defaultFontColor};

	.main-display {
		width: 100%;
		height: 240px;
		display: flex;
		justify-content: center;
		flex-direction: row;
		flex-wrap: wrap;
		#action-button {
			margin: 25px;
		}
		.ScrollbarsCustom-Track {
			right: 12px !important;
			top: 0px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.account} !important;
			width: 6px !important;
		}
		.ScrollbarsCustom-TrackY:before {
			border-left: none;
		}
		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 6px !important;
		}
	}
	.section {
		width: 100%;
		height: 200px;
		margin-top: 10px;
		.log-details-wrapper {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;

			.log-headings {
				width: 100%;
				min-height: 24px;
				display: flex;
				margin-bottom: 9px;
				.log-header {
					margin-right: 16px;
					display: flex;
					align-items: flex-end;
					text-align: left;
					background-color: ${props => props.theme.Cool_Gray_Med_3};
					&.username {
						width: 56px;
					}
					&.description {
						width: 160px;
					}
					&.city {
						width: 32px;
					}
					&.date,
					&.time {
						width: 48px;
					}
				}
			}
			.log-row {
				display: flex;
				width: 100%;
				height: 16px;
				margin-bottom: 9px;

				.log-body {
					margin-right: 16px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					background-color: ${props => props.theme.Cool_Gray_Med_3};
					&.username {
						width: 56px;
					}
					&.description {
						width: 160px;
					}
					&.city {
						width: 32px;
					}
					&.date,
					&.time {
						width: 48px;
					}
				}
			}
		}
	}

	.divider {
		width: 100%;
		height: 2px;
		border-radius: 15px;
		margin-top: 5px;
		background-color: ${props => props.theme.Cool_Gray_Light_3};
		box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${props => props.theme.boxShadow} inset;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 448px;
		height: 100%;
		color: ${props => props.theme.defaultFontColor};

		.main-display {
			width: 500px;
			height: 340px;
			display: flex;
			justify-content: center;
			flex-direction: row;
			flex-wrap: wrap;
			#action-button {
				margin: 25px;
			}
			.ScrollbarsCustom-Track {
				right: -38px !important;
				top: 0px !important;
			}

			.ScrollbarsCustom-ThumbY {
				width: 8px !important;
			}
			.ScrollbarsCustom-TrackY {
				width: 8px !important;
			}
		}
		.section {
			width: 500px;
			height: 280px;
			margin-top: 20px;
			margin-left: 50px;
			.log-details-wrapper {
				width: 100%;
				height: 100%;
				display: flex;
				flex-direction: column;

				.log-headings {
					width: 100%;
					min-height: 24px;
					display: flex;
					margin-bottom: 9px;
					.log-header {
						margin-right: 20px;
						display: flex;
						align-items: flex-end;
						text-align: left;
						background-color: ${props => props.theme.Cool_Gray_Med_3};
						&.username {
							min-width: 76px;
						}
						&.description {
							min-width: 180px;
						}
						&.city {
							min-width: 52px;
						}
						&.date,
						&.time {
							min-width: 68px;
						}
					}
				}
				.log-row {
					display: flex;
					width: 100%;
					height: 16px;
					margin-bottom: 9px;

					.log-body {
						margin-right: 20px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						background-color: ${props => props.theme.Cool_Gray_Med_3};
						&.username {
							min-width: 76px;
						}
						&.description {
							min-width: 180px;
						}
						&.city {
							min-width: 52px;
						}
						&.date,
						&.time {
							min-width: 68px;
						}
					}
				}
			}
		}

		.divider {
			width: 100%;
			height: 2px;
			border-radius: 15px;
			margin-top: 5px;
			background-color: ${props => props.theme.Cool_Gray_Light_3};
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px r ${props => props.theme.boxShadow} inset;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 950px;
		height: 100%;
		color: ${props => props.theme.defaultFontColor};

		.main-display {
			width: 850px;
			height: 340px;
			display: flex;
			justify-content: center;
			flex-direction: row;
			flex-wrap: wrap;
			#action-button {
				margin: 25px;
			}
			.ScrollbarsCustom-Track {
				right: -42px !important;
				top: 0px !important;
			}

			.ScrollbarsCustom-ThumbY {
				width: 10px !important;
			}
			.ScrollbarsCustom-TrackY {
				width: 10px !important;
			}
		}
		.section {
			width: 850px;
			height: 350px;
			margin-top: 10px;
			.log-details-wrapper {
				width: 100%;
				height: 100%;
				display: flex;
				flex-direction: column;

				.log-headings {
					width: 100%;
					min-height: 34px;
					display: flex;
					margin-bottom: 12px;
					.log-header {
						margin-right: 36px;
						display: flex;
						align-items: flex-end;
						text-align: left;
						background-color: ${props => props.theme.Cool_Gray_Med_3};
						&.username {
							min-width: 206px;
						}
						&.description {
							min-width: 210px;
						}
						&.city {
							min-width: 82px;
						}
						&.date,
						&.time {
							min-width: 98px;
						}
					}
				}
				.log-row {
					display: flex;
					width: 100%;
					height: 26px;
					margin-bottom: 9px;

					.log-body {
						margin-right: 36px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						background-color: ${props => props.theme.Cool_Gray_Med_3};
						&.username {
							min-width: 206px;
						}
						&.description {
							min-width: 210px;
						}
						&.city {
							min-width: 82px;
						}
						&.date,
						&.time {
							min-width: 98px;
						}
					}
				}
			}
		}

		.divider {
			width: 100%;
			height: 2px;
			border-radius: 15px;
			margin-top: 5px;
			background-color: ${props => props.theme.Cool_Gray_Light_3};
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.boxShadow} inset;
		}
	}
`;
function renderPortalAccess(logs) {
	return (
		<div className='log-details-wrapper'>
			<div className='log-headings'>
				<div className='log-header username '>
					<div className='title labels21'>USERNAME</div>
				</div>
				<div className='log-header description '>
					<div className='title labels21'>DESCRIPTION</div>
				</div>
				<div className='log-header city '>
					<div className='title labels21'>CITY</div>
				</div>
				<div className='log-header date '>
					<div className='title labels21'>DATE</div>
				</div>
				<div className='log-header time '>
					<div className='title labels21'>TIME</div>
				</div>
			</div>
			<div className='log-body'>
				{logs.map(log => (
					<div className='log-row'>
						<div className='log-body username body10'>{log?.username}</div>
						<div className='log-body description body10'>{log?.description}</div>
						<div className='log-body city body10'>{log?.city}</div>
						<div className='log-body date body10'>{log?.event_date}</div>
						<div className='log-body time body10'>{log?.event_time}</div>
					</div>
				))}
			</div>
		</div>
	);
}

export const PortalAccess = ({ role, user, organizationId }) => {
	const [portalAccessLogs, setLogs] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const params = {
			organizationId,
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		};
		UserApi.getPortalAccessDetails(params)
			.then(response => {
				const validResponse = response.status === 200 && response.data;
				if (validResponse) {
					if (role === 'member') {
						const logs = response.data?.orgUserSessionList;
						const filterLogsUserOnly = logs.filter(
							log => log.email_address === user?.contactDetails?.email,
						);
						setLogs(filterLogsUserOnly);
					} else {
						setLogs(response.data?.orgUserSessionList);
					}

					setIsLoading(false);
				} else {
				}
			})
			.catch(() => {
				setIsLoading(false);
			});
	}, [setLogs]);

	return (
		<PortalAccessDetails>
			<div className='main-display'>
				{isLoading && <LoadingCube />}
				{portalAccessLogs && portalAccessLogs.length !== 0 && !isLoading && (
					<div className='section'>
						{/* <div className='title heading70'>Badge Access Logs</div>
						<div className='divider'></div> */}
						<ScrollView>{renderPortalAccess(portalAccessLogs)}</ScrollView>

						<div className='divider'></div>
						<div className='main-footer'>
							{/* <BloxButton
								id={'notifications-button'}
								text='View More'
								onClick={onClick}
								module='account'
								enabled={true}
								className='buttons41'
							/> */}
						</div>
					</div>
				)}
				{portalAccessLogs.length === 0 && !isLoading && (
					<div className='section body10'>No recent activity to display.</div>
				)}
			</div>
		</PortalAccessDetails>
	);
};
// LargeInfoDisplay.propTypes = {
// 	type: string.isRequired,
// };

// LargeInfoDisplay.defaultProps = {};
